var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect } from 'react';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { DialogType } from '../../types/dialogs';
import { useInput } from '../common/use-input';
export function useAccountBillingInformation() {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var reconnectUser = useContext(UserContext).reconnectUser;
    var addressLine1 = useInput('');
    var addressLine2 = useInput('');
    var zipCode = useInput('');
    var city = useInput('');
    var state = useInput('');
    var country = useInput('');
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.UPDATE_BILLING_INFORMATION
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                text: t('common.confirm'),
                                action: function () {
                                    return updateBillingInformation({
                                        addressLine1: addressLine1.value,
                                        addressLine2: addressLine2.value,
                                        zipCode: zipCode.value,
                                        city: city.value,
                                        state: state.value,
                                        country: country.value,
                                    });
                                },
                                highlighted: true,
                                disabled: addressLine1.value.length === 0 ||
                                    zipCode.value.length === 0 ||
                                    city.value.length === 0 ||
                                    country.value.length === 0,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { addressLine1: addressLine1, addressLine2: addressLine2, zipCode: zipCode, city: city, state: state, country: country }),
                }
                : value;
        });
    }, [addressLine1.value, addressLine2.value, zipCode.value, city.value, state.value, country.value]);
    function hideDialog() {
        addressLine1.setValue('');
        addressLine1.setError(undefined);
        addressLine2.setValue('');
        addressLine2.setError(undefined);
        zipCode.setValue('');
        zipCode.setError(undefined);
        city.setValue('');
        city.setError(undefined);
        state.setValue('');
        state.setError(undefined);
        country.setValue('');
        country.setError(undefined);
        setDialogProps(undefined);
    }
    function showUpdateBillingInformationDialog() {
        setDialogProps({
            common: {
                title: t('account.my-info.udpate-billing-information.title'),
                close: { text: t('common.back'), action: hideDialog },
                actions: [
                    {
                        text: t('common.confirm'),
                        highlighted: true,
                        disabled: true,
                    },
                ],
            },
            custom: {
                type: DialogType.UPDATE_BILLING_INFORMATION,
                addressLine1: addressLine1,
                addressLine2: addressLine2,
                zipCode: zipCode,
                city: city,
                state: state,
                country: country,
            },
        });
    }
    function updateBillingInformation(input) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setServerLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, gqlSdk.UserUpdateBillingAddress({
                                input: {
                                    line1: input.addressLine1,
                                    line2: input.addressLine2.length > 0 ? input.addressLine2 : undefined,
                                    postalCode: input.zipCode,
                                    city: input.city,
                                    state: input.state.length > 0 ? input.state : undefined,
                                    country: input.country,
                                },
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            if (err_1 instanceof Error) {
                                console.log(err_1.message);
                            }
                            error = t('error.generic');
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 6];
                        return [4 /*yield*/, reconnectUser()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        setServerLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('account.my-info.udpate-billing-information.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    return { showUpdateBillingInformationDialog: showUpdateBillingInformationDialog };
}
